export default "__VITE_ASSET__CVrtRS1E__"